import { Box } from "@mui/material"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { PrincipalLayouts } from "../../layouts"
import { StartupTable } from "../components/startup/StartupTable"
import { StartupValorationTable } from "../components/startup/valoration/StartupValorationTable"
import { fetchData } from "../helpers/getData/fetchData"

export const Startup = () => {

  const {t} = useTranslation('global')
  const [startupList, setStartupList] = useState('loading')
  const [startupValorationList, setStartupValorationList] = useState('loading')
  const [reloadData, setReloadData] = useState(false)

  useEffect(() => {
    fetchData(setStartupList, '/startups');
    fetchData(setStartupValorationList, '/startupValoration', t);
  }, [reloadData, t])

  return (
    <PrincipalLayouts>
      <Box sx={{ width: '100%', display:'flex', flexDirection:'column', gap:10 }}>
        {
          startupList !== 'loading' &&
          <StartupTable rows={startupList} setReloadData={setReloadData} />
        }
        {
          startupValorationList !== 'loading' &&
          <StartupValorationTable rows={startupValorationList} setReloadData={setReloadData} />
        } 
      </Box>
    </PrincipalLayouts>
  )
}
